/**
 * Facture PDF — téléchargeable si statut final LIVREE/RETIREE,
 * ou si une facture a déjà été émise (ex. ANNULEE après refund total).
 */

export const FACTURE_STATUTS_AUTORISES = new Set(['LIVREE', 'RETIREE']);

export function isFactureDisponiblePourStatut(statut) {
  return FACTURE_STATUTS_AUTORISES.has(String(statut || '').toUpperCase().trim());
}

/**
 * @param {{ statut?: unknown, numeroFacture?: string|null }} commande
 */
export function isFactureTelechargeable(commande = {}) {
  if (commande?.numeroFacture) return true;
  return isFactureDisponiblePourStatut(commande?.statut);
}
